const groups = [
  {
    title: "追更导航",
    links: [
      { href: "#updates", label: "最新更新" },
      { href: "#ranking", label: "追更榜" },
      { href: "#featured", label: "热门连载" },
      { href: "#faq", label: "常见问题" },
    ],
  },
  {
    title: "分类入口",
    links: [
      { href: "#categories", label: "热血少年" },
      { href: "#categories", label: "奇幻冒险" },
      { href: "#categories", label: "恋爱日常" },
      { href: "#categories", label: "悬疑推理" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2" aria-label="妖精漫画首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">妖精漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              妖精漫画追更入口，专注连载进度与最新话更新提醒。收藏你追的漫画，
              每次打开都能看到有没有新章节，追更体验顺畅。
            </p>
            <p className="mt-4 text-sm text-foreground-500">
              联系邮箱：hello@yaojing-mh.example
            </p>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h4 className="text-sm font-bold text-foreground-950">{g.title}</h4>
              <ul className="mt-4 space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 妖精漫画 · 只为更好的追更体验
          </p>
          <div className="flex items-center gap-3 text-foreground-500">
            <a href="#top" aria-label="回到顶部" className="flex h-9 w-9 items-center justify-center rounded-md transition-colors hover:bg-background-200">
              <i className="ri-arrow-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}